<template>
  <nav
    v-if="items?.length"
    class="nav-static"
    :aria-label="navigationLabel"
  >
    <ul class="nav-static__list">
      <li
        v-for="item in items"
        :key="item.url"
        class="nav-static__item"
      >
        <atomic-link
          :href="item.url"
          :target-blank="item?.targetBlank"
          class="nav-static__link"
        >
          {{ item.label }}
        </atomic-link>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import type { ILink } from '~/types';

const props = defineProps<{
  items?: ILink[];
  title?: string;
}>();

const navigationLabel = computed(() => {
  return props.title || 'Info menu';
});
</script>

<style src="~/assets/styles/components/nav/static.scss" lang="scss" />
